export default __webpack_public_path__ + "static/media/email-in-circle-gradient.6731c4d8.svg";